import type { Dictionary } from "./translations";

export const zhCN: Dictionary = {
  "meta.title": "AgentBuck - AI 模型价格比较",
  "meta.description": "比较主流 AI 模型的 API 价格，并根据实际 Token 用量估算每月成本。",
  "nav.prices": "模型价格",
  "nav.calculator": "成本计算器",
  "nav.providers": "服务商",
  "nav.guide": "价格指南",
  "nav.method": "计算方法",
  "aria.home": "AgentBuck 首页",
  "aria.language": "选择语言",
  "aria.navigation": "主导航",
  "aria.breadcrumb": "面包屑导航",
  "aria.dark": "切换到深色模式",
  "aria.light": "切换到浅色模式",
  "title.dark": "深色模式",
  "title.light": "浅色模式",
  "hero.eyebrow": "AI API 价格数据库",
  "hero.title": "找到适合预算的 AI 模型",
  "hero.subtitle": "以统一标准比较输入、输出和缓存价格，再根据实际 Token 用量估算每月成本。",
  "stats.models": "可比较模型",
  "stats.providers": "主流服务商",
  "stats.updated": "数据更新时间",
  "common.loading": "加载中",
  "notice.snapshot": "实时数据暂不可用，正在显示 2026 年 9 月 7 日的内置快照。",
  "common.retry": "重试",
  "common.home": "首页",
  "common.models": "模型",
  "common.providers": "服务商",
  "common.from": "起价",
  "common.viewAll": "查看全部",
  "common.backPricing": "返回价格表",
  "share.quick": "分享此页面",
  "share.kicker": "与团队分享",
  "share.title": "分享此比较",
  "share.description": "分享此页面，保留所选模型和完整用量假设。",
  "share.copy": "复制链接",
  "share.copied": "链接已复制",
  "share.more": "分享",
  "share.openComparison": "打开分享页面",
  "share.email": "电子邮件",
  "calculator.title": "每月成本计算器",
  "calculator.input": "每月输入",
  "calculator.output": "每月输出",
  "calculator.cache": "缓存输入占比",
  "calculator.million": "百万 Token",
  "calculator.cheapest": "当前成本最低的 5 款模型",
  "calculator.perMonth": "预估 / 月",
  "prices.title": "模型价格",
  "prices.subtitle": "标准实时 API，美元 / 百万 Token",
  "filter.open": "筛选",
  "filter.search": "搜索模型或服务商",
  "filter.clearSearch": "清除搜索",
  "filter.provider": "按服务商筛选",
  "filter.allProviders": "所有服务商",
  "filter.sort": "模型排序",
  "filter.favorite": "已收藏",
  "sort.monthly": "预估每月成本",
  "sort.input": "输入价格",
  "sort.output": "输出价格",
  "sort.context": "上下文窗口",
  "sort.newest": "最新发布",
  "cap.reasoning": "推理",
  "cap.tools": "工具调用",
  "cap.vision": "视觉",
  "cap.structured": "结构化输出",
  "cap.openWeights": "开放权重",
  "results.found": "找到 {count} 款模型",
  "results.source": "价格根据公开定价统一换算，请查阅服务商文档核实。",
  "column.compare": "比较",
  "column.model": "模型 / 服务商",
  "column.input": "输入",
  "column.cached": "缓存输入",
  "column.output": "输出",
  "column.monthly": "预估月费",
  "column.context": "上下文",
  "column.capabilities": "推理  工具  视觉",
  "column.actions": "操作",
  "action.officialDocs": "官方文档",
  "action.addCompare": "加入比较",
  "action.removeCompare": "移出比较",
  "action.addFavorite": "收藏模型",
  "action.removeFavorite": "取消收藏",
  "action.added": "已添加",
  "context.suffix": "上下文",
  "empty.title": "没有匹配的模型",
  "empty.description": "请尝试其他搜索词，或清除能力筛选条件。",
  "empty.clear": "清除筛选",
  "home.exploreKicker": "探索模型目录",
  "home.exploreTitle": "更多 AI 模型比较方式",
  "home.providersTitle": "按服务商浏览",
  "home.providersBody": "比较 OpenAI、Anthropic、Google、DeepSeek、Alibaba 等服务商的所有收录模型。",
  "home.guideTitle": "阅读价格指南",
  "home.guideBody": "了解 Token 配比、提示词缓存、上下文阶梯定价及影响 API 账单的因素。",
  "home.open": "打开",
  "providers.kicker": "服务商目录",
  "providers.title": "AI 模型服务商",
  "providers.intro": "查看 AgentBuck 目录中各大服务商统一换算的 API 价格、上下文上限和模型能力。",
  "providers.models": "{count} 款模型",
  "providers.starting": "最低输入单价",
  "providers.view": "查看服务商",
  "provider.kicker": "服务商价格",
  "provider.titleSuffix": "API 价格",
  "provider.description": "按输入价格、输出价格、上下文窗口和生产能力，比较 {name} 的 {count} 款模型。",
  "provider.cheapest": "最低输入价格",
  "provider.largestContext": "最大上下文",
  "provider.updated": "目录更新时间",
  "model.kicker": "模型价格详情",
  "model.title": "{name} API 价格",
  "model.descriptionFallback": "比较此模型的 API Token 单价、上下文上限、能力和预估每月成本。",
  "model.input": "输入 / 百万 Token",
  "model.cache": "缓存输入 / 百万 Token",
  "model.output": "输出 / 百万 Token",
  "model.context": "上下文窗口",
  "model.maxOutput": "最大输出",
  "model.released": "发布日期",
  "model.updated": "模型更新时间",
  "model.estimateTitle": "您的每月成本估算",
  "model.estimateBody": "按输入 {input} 百万 Token、输出 {output} 百万 Token 和 {cache}% 缓存输入计算。",
  "model.relatedTitle": "{provider} 的更多模型",
  "compare.pageTitle": "共享 AI 模型成本比较",
  "compare.pageBody": "使用此链接中保存的用量假设，比较 Token 单价、上下文窗口、能力和每月成本。",
  "compare.emptyTitle": "此比较中没有模型",
  "compare.emptyBody": "从价格表中选择两到三款模型，创建可分享的比较。",
  "compare.start": "选择模型",
  "compare.usage": "共享用量",
  "notFound.title": "未找到页面",
  "notFound.body": "页面可能已移动，或此模型已不在当前目录中。",
  "guide.kicker": "实用选购指南",
  "guide.title": "按实际工作负载比较 AI API 价格",
  "guide.intro": "最低输入单价不一定意味着最低总账单。AgentBuck 将提示词、缓存提示词和生成 Token 的费用合并，让 GPT、Claude、Gemini、DeepSeek、Qwen、Grok 等模型在相同用量下进行比较。",
  "guide.inputTitle": "从 Token 配比开始",
  "guide.inputBody": "聊天机器人通常消耗更多输入 Token，而编程智能体和推理系统可能生成更多输出。这会改变最具性价比的模型选择。",
  "guide.cacheTitle": "计入提示词缓存",
  "guide.cacheBody": "重复的系统提示词和较长的共享上下文，会让缓存读取价格成为关键因素。比较每月总成本前，请设置合理的缓存占比。",
  "guide.fitTitle": "确认能力和上下文",
  "guide.fitBody": "只有模型满足上下文窗口、视觉输入、推理深度、结构化输出和工具调用需求时，价格比较才有意义。",
  "faq.kicker": "常见问题",
  "faq.title": "AI 模型价格常见问题",
  "faq.q1": "AgentBuck 如何比较 AI 模型的 API 价格？",
  "faq.a1": "AgentBuck 将标准实时 API 价格统一为每百万 Token 的美元价格，并分别列出输入、缓存输入和输出费用，同时提供服务商文档链接以供核实。",
  "faq.q2": "哪款 AI 模型的 API 最便宜？",
  "faq.a2": "没有适用于所有场景的最便宜模型。结果取决于输入输出比例、缓存使用情况和所需能力。输入上方的每月用量，即可按实际工作负载为模型排序。",
  "faq.q3": "如何计算大语言模型的预估每月成本？",
  "faq.a3": "将未缓存输入、缓存输入和输出的用量分别乘以对应模型单价后相加。估算不含税费、批处理折扣、区域定价和长上下文附加费。",
  "faq.q4": "为什么有些模型显示为零美元？",
  "faq.a4": "部分服务商为特定模型提供免费或促销使用。可用性和限制可能变化，在生产环境使用前请核实链接中的服务商文档。",
  "faq.q5": "价格数据多久更新一次？",
  "faq.a5": "AgentBuck 每六小时刷新一次结构化价格目录。模型表显示上游最新的模型更新时间，实际计费仍以服务商条款为准。",
  "method.title": "数据与计算方法",
  "method.priceTitle": "价格基准",
  "method.priceBody": "采用标准实时 API 的美元 / 百万 Token 价格，不含税费、批处理价格、区域加价和长上下文阶梯定价。",
  "method.sourceTitle": "数据来源",
  "method.sourceBefore": "将公开模型目录和服务商价格页面统一整理为可比较的数据集。",
  "method.sourceAfter": "AgentBuck 每六小时更新一次，并提供服务商文档链接供核实。",
  "method.costTitle": "成本估算",
  "method.costBody": "每月成本 = 普通输入 + 缓存输入 + 输出。此估算用于预算规划，实际账单以服务商控制台为准。",
  "footer.tagline": "让每个 Token 都物有所值。",
  "footer.updated": "数据更新时间：{date}",
  "compare.selected": "已选 {count}/3",
  "compare.remove": "移除 {name}",
  "compare.button": "比较模型",
  "compare.kicker": "模型比较",
  "compare.title": "并排比较价格与能力",
  "compare.close": "关闭",
  "compare.input": "输入 / 百万 Token",
  "compare.cache": "缓存 / 百万 Token",
  "compare.output": "输出 / 百万 Token",
  "compare.monthly": "预估每月成本",
  "compare.context": "上下文",
  "compare.capabilities": "推理 / 工具 / 视觉",
  "compare.docs": "服务商文档",
  "compare.viewPrice": "查看价格",
  "nav.requestCalculator": "请求成本计算器",
  "home.calculatorTitle": "按请求量估算成本",
  "home.calculatorBody": "根据每日请求数、每次请求的 Token 数和缓存命中率计算每月支出。",
  "home.compareDirectoryTitle": "浏览模型对比",
  "home.compareDirectoryBody": "从精选对比开始，或从价格表创建自己的对比。",
  "model.formulaTitle": "成本计算公式",
  "model.formulaBody": "每月成本 =（未缓存输入 Token × 输入单价）+（缓存输入 Token × 缓存读取单价）+（输出 Token × 输出单价），均按每百万 Token 计算。若未公布缓存读取单价，缓存 Token 按标准输入单价估算。",
  "model.exampleTitle": "可复现示例",
  "model.exampleBody": "示例：{inputM} 输入 Token（其中 {cachePercent}% 来自缓存）和 {outputM} 输出 Token，按该模型公开价格计算为 {total}——每百万 Token 输入 {inputRate}、缓存输入 {cacheRate}、输出 {outputRate}。",
  "model.calculatorCta": "按每日请求量估算成本",
  "model.comparisonsTitle": "已收录于以下精选对比",
};
